import { Directive, AfterViewInit, ElementRef } from '@angular/core';

@Directive({
  selector: '[appTab]'
})
export class TabDirective implements AfterViewInit {

  constructor(private elementRef: ElementRef) { }

  ngAfterViewInit() {
    ($(this.elementRef.nativeElement) as any).tab();
  }

}
